<template>
  <div class="discount-summary">
    <adjustment
      v-if="summary.promotionDiscount"
      :adjustment="summary.promotionDiscount"
      :is-discount="true"
      @updateCart="updateCart"
    ></adjustment>

    <adjustment
      v-if="shouldShowBlinkedLostAdjustment"
      :adjustment="promotionApplied"
      :is-discount="true"
      @updateCart="updateCart"
    ></adjustment>

    <adjustment
      v-for="(adjustment, index) in summary.adjustmentTotal"
      :key="index"
      :adjustment="adjustment"
      :is-discount="true"
      @updateCart="updateCart"
    />

    <div class="discount-summary__item">
      <span class="discount-summary__item-label">
        {{ $t('cart.total_economy') }}
      </span>
      <span class="discount-summary__item-price">
        {{ $isGlobalStore ? discountTotal : formatPrice(discountTotal) }}</span
      >
    </div>
  </div>
</template>

<script>
import priceable from '~/mixins/priceable'
import Adjustment from '~/components/cart/adjustment/Adjustment.vue'

export default {
  components: {
    Adjustment,
  },
  mixins: [priceable],
  props: {
    summary: {
      type: Object,
      required: true,
    },
    promotionApplied: {
      type: Object,
      required: true,
    },
    discountTotal: {
      type: Number,
      required: true,
    },
    shouldShowBlinkedLostAdjustment: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateCart(cart) {
      this.$emit('updateCart', cart)
    },
  },
}
</script>

<style lang="scss" scoped>
.discount-summary {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  line-height: normal;
  width: 100%;

  .discount-summary__item {
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    line-height: normal;
    text-align: right;
    width: 100%;
    font-size: 15px;
    padding-bottom: 5px;

    .discount-summary__item-label {
      font-weight: bold;
    }

    .discount-summary__item-price {
      width: 80px;
      color: $v4_color_primary;
      font-weight: bold;
    }
  }
}
</style>
